import { render, staticRenderFns } from "./SnackbarContainer.vue?vue&type=template&id=754814e3"
import script from "./SnackbarContainer.vue?vue&type=script&lang=js"
export * from "./SnackbarContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports